

















































import AbpBase from "@/lib/abpbase";
import { Component } from "vue-property-decorator";
import { GetListByCode } from "@/api/configureDictionary";
import { QueryPDTransferList } from "@/api/pdTransferAndChangeBed/pdTransfer";
import { GetDoctor } from "@/api/dialysisProcess";
import QueryBoard from "@/components/query-board.vue";
import PdOutPatientMain from "../../pdOutPatient/pdOutPatientIndex/main.vue";

@Component({
  components: {
    QueryBoard,
    PdOutPatientMain
  }
})
export default class PdTransfer extends AbpBase {
  showPatientDetail: boolean = false;
  currentPatient: any = {};
  date: any = [];
  doctorList: any = [];
  /**
   * 表格数据
   */
  tableData: any[] = [];
  tableTotalSize: number = 0;
  /**
   * 加载状态
   */
  loading: boolean = false;

  /**
   * 查询条件
   */
  queryCondition: any = {
    startDate: null,
    endDate: null,
    SkipCount: 1,
    MaxResultCount: 10,
    SortKey: "id",
    SortOrder: "asc",
    PsnlNo: "",
    Name: "",
    CID: "",
    Card: "",
    Sex: null,
    PayType: "",
    AgeStart: null,
    AgeEnd: null,
    CreationTimeStart: null,
    CreationTimeEnd: null,
    Status: null
  };
  /**
   * 列表
   */
  columns = [
    {
      key: "bedNo",
      title: "床位",
      minWidth: 90,
      sortable: "custom"
    },
    {
      key: "pD_Patient_Hospitalization_ID",
      title: "住院号",
      minWidth: 90,
      sortable: "custom"
    },
    {
      key: "name",
      title: "姓名",
      minWidth: 120,
      sortable: "custom"
    },
    {
      key: "sexName",
      title: "性别",
      minWidth: 90,
      sortable: "custom"
    },
    {
      key: "outDepartmentDate",
      title: "转科时间",
      minWidth: 160,
      sortable: "custom",
      render: (h: any, p: any) => {
        return h("span", {}, this.formatDate(p.row.outDepartmentDate));
      }
    },
    {
      key: "outDepartment",
      title: "转出科室",
      minWidth: 180,
      sortable: "custom"
    },

    {
      key: "inDepartment",
      title: "转入科室",
      minWidth: 120,
      sortable: "custom"
    },
    {
      key: "assignName",
      title: "负责医生",
      minWidth: 120,
      sortable: "custom"
    },
    {
      key: "remarks",
      title: "备注",
      minWidth: 200,
      sortable: "custom"
    },
    {
      key: "",
      minWidth: 150,
      title: "操作",
      render: (h: any, p: any) => {
        return h("div", [
          h("Button", {
            props: { type: "default", icon: "md-book", size: "small" },
            style: { marginRight: "20px" },
            on: {
              click: () => {
                this.basicInfo(p.row);
              }
            }
          })
        ]);
      }
    }
  ];
  /**
   * 代码表
   */
  initDic() {
    GetDoctor().then(res => {
      if (res) {
        this.doctorList = res.objects;
      }
    });
  }

  //基本信息
  basicInfo(row: any) {
    this.currentPatient = row.transferPatient;
    this.showPatientDetail = true;
  }

  pageChange(val: any) {
    this.queryCondition.SkipCount = val;
    this.getData();
  }

  onSortChange(res: any) {
    this.queryCondition.SortKey = res.key;
    this.queryCondition.SortOrder = res.order;
    this.getData();
  }

  async getData() {
    this.loading = true;
    this.queryCondition.startDate = this.date[0];
    this.queryCondition.endDate = this.date[1];
    await QueryPDTransferList(this.queryCondition)
      .then(res => {
        this.tableData = res.items;
        this.tableTotalSize = res.totalCount;
        this.loading = false;
      })
      .catch(res => {
        this.loading = false;
      });
  }

  created() {
    const end = new Date();
    const start = new Date();
    start.setTime(end.getTime() - 3600 * 1000 * 24 * 6);
    this.date = [start, end];
    this.getData();
    this.initDic();
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/pdTransferAndChangeBed/pdTransfer/index.vue